module.exports = __webpack_public_path__ + "media/images/landing-pages/stem_primary_course-2fe7bfa853bdc5ec72944f1dccfebb19.png";